<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='showModal') 順番変更
  .contents-container
    el-table.c-table(:data='list' style='width: 100%' v-loading='LOADING')
      el-table-column(prop='main_image' label='', width='120')
        template(slot-scope='scope')
          template(v-if='scope.row.thumbnail')
            img.c-thumb__item--s(:src='scope.row.thumbnail.rectangle.uri')
          template(v-else-if='scope.row.main_image')
            img.c-thumb__item--s(:src='scope.row.main_image.uri')
          template(v-else)
            .c-thumb__item--s
              p no image
      el-table-column(prop='title.ja' label='タイトル')
      el-table-column(prop='date' label='日付' width='120')
      el-table-column(prop='news_type' label='タイプ' width='120')
        template(slot-scope='scope')
          | {{getNewsType(scope.row.news_type)}}
      el-table-column(prop='no' label='No' width='80')
    template(v-if='list.length')
      modal-sort-element(:visible='modalvisible' @hideModal='hideModal' @saveSort='saveSort' :list='list' type='list')
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Sticky from '@/components/Element/Sticky'
import ModalSortElement from '@/components/Element/Modal/SortElement'
import * as apiMergedNews from '@/api/merged_news'

export default {
  name: 'PagesMargedNews',
  data () {
    return {
      list: [],
      sortable: null,
      originList: [],
      sortedList: [],
      modalvisible: false
    }
  },
  methods: {
    init () {
      this.getList()
    },
    getList () {
      this.getMergedNews().then(() => {
        this.list = this.mergedNews
        this.originList = this.list.map(v => v.id)
        this.sortedList = this.originList.slice()
      })
    },
    getNewsType (type) {
      const typeMap = {
        1: 'Press',
        2: 'Newsletter'
      }
      return typeMap[type] || type
    },
    showModal () {
      this.modalvisible = true
    },
    hideModal () {
      this.modalvisible = false
    },
    saveSort (list) {
      this.$store.commit('LOADER', true)
      apiMergedNews.postSort(list).then((res) => {
        this.$store.commit('LOADER', false)
        this.getList()
        this.hideModal()
      })
    },
    ...mapActions([
      'getMergedNews'
    ])
  },
  computed: {
    ...mapGetters([
      'LOADING',
      'mergedNews'
    ])
  },
  mounted () {
    this.init()
  },
  components: {
    Sticky,
    ModalSortElement
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MargedNews/index.vue